import gql from 'not-graphql-tag';

export const sendNewTrustedDeviceAddedEmailMutation = gql`
  mutation sendNewTrustedDeviceAddedEmail(
    $payload: SendNewTrustedDeviceAddedEmailInput!
  ) {
    sendNewTrustedDeviceAddedEmail(payload: $payload) {
      isSuccessful
    }
  }
`;
